import { useEffect, useState } from 'react';
import { readListPreference, writeListPreference } from './listPreferences';

// A list's sort that is remembered in this browser under storageKey (see listPreferences): it starts from
// what the agent last picked, or the list's default, and every new pick is saved.
// resetSortOrder goes back to the default and forgets the saved one, so a Reset View has nothing left to reset.
export const usePersistedSort = <T>(storageKey: string, fallback: T): [T, (next: T) => void, () => void] => {
  const [sortOrder, setSortOrder] = useState<T>(() => readListPreference<T>(storageKey) ?? fallback);

  useEffect(() => {
    setSortOrder(readListPreference<T>(storageKey) ?? fallback);
  }, [storageKey]);

  const saveSortOrder = (next: T) => {
    setSortOrder(next);
    writeListPreference(storageKey, next);
  };

  const resetSortOrder = () => {
    setSortOrder(fallback);
    writeListPreference(storageKey, null);
  };

  return [sortOrder, saveSortOrder, resetSortOrder];
};
